import { Select } from "@ttc3k/trekker";
import { EnumTagGroupKey, EnumTagGroupType } from "gql/generated";
import { useMemo } from "react";

type UseTagGroupsCollectionProps = {
  flyoutCategoryOptions: {
    value: string;
    label: string;
    key: EnumTagGroupKey;
    type: EnumTagGroupType;
  }[];
};

export const useTagGroupsCollection = ({
  flyoutCategoryOptions,
}: UseTagGroupsCollectionProps) => {
  const tagGroupsCollection = useMemo(
    () =>
      Select.createCollection({
        items: flyoutCategoryOptions,
      }),
    [flyoutCategoryOptions],
  );

  return {
    tagGroupsCollection,
  };
};
